import { handleActions } from 'redux-actions'

// Actions
import {
  fetchRolesFailure,
  fetchRolesRequest,
  fetchRolesSuccess
} from 'src/actions/roles'

// Types
import { Role } from '@120wateraudit/envirio-components/dist/models'

export interface RolesState {
  error: any
  isFetching: boolean
  items: Role[]
}

const initialState = {
  error: undefined,
  isFetching: false,
  items: []
}

const rolesReducer = handleActions(
  {
    [fetchRolesRequest.toString()]: (state: any, action: any) => ({
      ...state,
      error: undefined,
      isFetching: true
    }),
    [fetchRolesSuccess.toString()]: (state: any, action: any) => ({
      ...state,
      error: undefined,
      isFetching: false,
      items: action.payload.roles
    }),
    [fetchRolesFailure.toString()]: (state: any, action: any) => ({
      ...state,
      error: action.payload.error,
      isFetching: false
    })
  },
  initialState
)

export default rolesReducer
